import { render, staticRenderFns } from "./page-content-wrapper.vue?vue&type=template&id=ff5c9fc8&scoped=true&"
import script from "./page-content-wrapper.vue?vue&type=script&lang=ts&"
export * from "./page-content-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./page-content-wrapper.vue?vue&type=style&index=0&id=ff5c9fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5c9fc8",
  null
  
)

export default component.exports